import React, { Component } from 'react';

class Footer extends Component {
	render() {
	return (
		<div style={{ textAlign: 'center', margin: '5em 0' }}>
			<a href="https://geo.music.apple.com/us/artist/yung-dank/1475707400?mt=1&app=music&ls=1" ><i className="ui big inverted apple icon"></i></a>
			<a href="https://open.spotify.com/artist/0DHmDPc6GwafJBrWc9yGZV?si=Wt0w3wQISbGrg5x0OR3AEw" ><i className="ui big inverted spotify icon"></i></a>
			<a href="https://twitter.com/fuckyungdank" ><i className="ui big inverted twitter icon"></i></a>
			<a href="https://www.instagram.com/yungdank/?hl=en" ><i className="ui big inverted instagram icon"></i></a>
		</div>
	);
	}
};

export default Footer;